import { Name } from '@ori-events/favorites-updated';
import type { Data } from '@ori-events/favorites-updated';

export const dispatchFavoritesUpdatedEvent = (detail: Data) =>
  window.dispatchEvent(new CustomEvent<Data>(Name, { detail }));
